<div fxLayout="row" fxLayoutAlign="center center" class="container" [ngClass]="priorityLevel | lowercase">
    <div fxLayout="column" fxLayoutAlign="start start">
        @for (i of priorityItems; track $index) {
            <div class="priority-level" [ngClass]="priorityLevel | lowercase"></div>
        }
    </div>
    <div class="ml-4 t6">{{ ('i18n_af_priorityLevel#' + priorityLevel) | translate }}</div>
</div>
